import css from './feedback.module.css';

interface Props {
  variant?: 'skeleton' | 'spinner';
  rows?: number;
  height?: number;
}

export function LoadingState({ variant = 'skeleton', rows = 3, height }: Props) {
  if (variant === 'spinner') {
    return (
      <div className={css.spinnerWrap} role="status" aria-label="Loading">
        <span className={css.spinner} />
      </div>
    );
  }
  return (
    <div className={css.skeletonWrap} aria-busy aria-live="polite">
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className={css.skeletonRow}
          style={height ? { height } : undefined}
        />
      ))}
    </div>
  );
}
